import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { TreeModule } from 'angular-tree-component';
import { AppComponent } from './app.component';
import { LaborService } from './labor.service';
import { DataService } from './data.service';

import { LaborComponent } from './labor/labor.component';
import { VinComponent } from './vin/vin.component';
import { AboutComponent } from './about/about.component';
import { PartComponent } from './part/part.component';
import { MyLabortreeDirective } from './my-labortree.directive';
import { LabordialogComponent } from './labordialog/labordialog.component';

import {
  MatButtonModule,
  MatDialogModule,
  MatFormFieldModule,
  MatInputModule,
  MatOptionModule,
  MatSelectModule,
  MatTableModule,
  MatMenuModule,
  MatIconModule,
  MatCheckboxModule,
  MatProgressSpinnerModule,
  MatDividerModule,
  MatExpansionModule,
  MatTabsModule,
  MatAutocompleteModule
} from '@angular/material';

import { LaborsearchComponent } from './laborsearch/laborsearch.component';
import { UnverifiedLaborComponent } from './unverified-labor/unverified-labor.component';
import { ProdemandComponent } from './prodemand/prodemand.component';
import { AlldataComponent } from './alldata/alldata.component';
import { PartInfoComponent } from './part-info/part-info.component';
import { LaborInfoComponent } from './labor-info/labor-info.component';
import { LoginComponent } from './login/login.component';
import { LabordetailComponent } from './labordetail/labordetail.component';
import { LabortreeComponent } from './labortree/labortree.component';
import { AutofocusDirective } from './autofocus.directive';
import { DetectchangeComponent } from './detectchange/detectchange.component';
import { CopyComponent } from './copy/copy.component';
import { UnconfirmedLaborComponent } from './unconfirmed-labor/unconfirmed-labor.component';
import { LaborDetailDialogComponent } from './labor-detail-dialog/labor-detail-dialog.component';


@NgModule({
  declarations: [
    AppComponent,
    LaborComponent,
    VinComponent,
    AboutComponent,
    PartComponent,
    MyLabortreeDirective,
    LabordialogComponent,
    LaborsearchComponent,
    UnverifiedLaborComponent,
    ProdemandComponent,
    AlldataComponent,
    PartInfoComponent,
    LaborInfoComponent,
    LoginComponent,
    LabordetailComponent,
    LabortreeComponent,
    AutofocusDirective,
    DetectchangeComponent,
    CopyComponent,
    UnconfirmedLaborComponent,
    LaborDetailDialogComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTableModule,
    MatMenuModule,
    MatIconModule,
    TreeModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatExpansionModule,
    MatTabsModule,
    ReactiveFormsModule,
    TreeModule.forRoot()
  ],
  entryComponents: [LabordialogComponent, CopyComponent, LaborsearchComponent, UnverifiedLaborComponent, DetectchangeComponent,LaborDetailDialogComponent],
  providers: [LaborService, DataService],
  bootstrap: [AppComponent],  
})
export class AppModule { }
